











































































import {
  SettingManagementCreateSettingRequest,
  SettingManagementListSettingRequest,
  SettingManagementSettingDTO,
  SettingManagementSettingService,
} from "@/common/api";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import SettingEditComponent from "@/components/admin/setting/settingEditComponent.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import PaginateModel from "@/model/paginate";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "SettingListComponent",
  components: {
    QMultiSelect,
    QSearch,
    QPaginate,
    QTableHeader,
    SettingEditComponent,
  },
})
export default class SettingListComponent extends Vue {

  public headers = [
    { id: "created_at", name: "作成日", order: "desc" },
    { id: "category", name: "カテゴリ", order: "" },
    { id: "addr", name: "略称", order: "" },
    { id: "context", name: "名称（日）" },
    { id: "context_en", name: "名称（英）" },
    { id: "context_cn", name: "名称（中）" },
    { id: "", name: "" },
  ];

  public categories = [
    {
      id: SettingManagementCreateSettingRequest.category.BREEDER,
      name: "生産者",
    },
    {
      id: SettingManagementCreateSettingRequest.category.VARIETY,
      name: "品種",
    },
    {
      id: SettingManagementCreateSettingRequest.category.PARENT_CARP,
      name: "親鯉",
    },
    {
      id: SettingManagementCreateSettingRequest.category.NOTE,
      name: "備考",
    },
    {
      id: SettingManagementCreateSettingRequest.category.AWARD_TITLE,
      name: "賞名称",
    },
    {
      id: SettingManagementCreateSettingRequest.category.AWARD_GROUP,
      name: "部門",
    },
    {
      id: SettingManagementCreateSettingRequest.category.OWNER,
      name: "オーナー",
    },
  ];

  public filter: SettingManagementListSettingRequest = {
    keyword: "",
    sort: "created_at",
    direction: SettingManagementListSettingRequest.direction.DESC,
    perPage: 30,
    page: 1,
    categories: [],
  };

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public dictionary: SettingManagementSettingDTO[] = [];
  public showEditPopup(id = null) {
    (this.$refs.SettingEditComponentPopUp as SettingEditComponent).show(id);
  }

  public created() {
    const currentQuery = this.$router.currentRoute.query;
    if (currentQuery.categories) {
      const categories = currentQuery.categories;
      if (typeof categories === "string") {
        this.filter.categories = [categories];
      } else if (typeof categories === "object") {
        this.filter.categories = categories as string[];
      }
    }

    if (currentQuery.direction) {
      this.filter.direction = String(
        currentQuery.direction,
      ) as SettingManagementListSettingRequest.direction;
    }

    if (currentQuery.sort) {
      this.filter.sort = String(currentQuery.sort);
    }

    if (currentQuery.page) {
      this.filter.page = Number(currentQuery.page);
    }

    if (currentQuery.title) {
      this.filter.keyword = String(currentQuery.keyword);
    }

    this.getDictionary(this.filter);
  }

  public search(query: any = {}) {
    const newQuery = {
      keyword: this.filter.keyword,
      page: this.filter.page,
      sort: this.filter.sort,
      direction: this.filter.direction,
      categories: this.filter.categories,
      ...query,
    };

    this.$router.push({ query: newQuery }).catch(() => {
      //
    });

    query = {
      ...this.filter,
      ...query,
    };

    this.getDictionary(query);
  }

  public resetSearch() {
    this.filter = {
      keyword: "",
      sort: "created_at",
      direction: SettingManagementListSettingRequest.direction.DESC,
      perPage: 30,
      page: 1,
      categories: [],
    };

    this.headers = [
      { id: "created_at", name: "作成日", order: "desc" },
      { id: "category", name: "カテゴリ", order: "" },
      { id: "addr", name: "略称", order: "" },
      { id: "context", name: "名称（日）" },
      { id: "context_en", name: "名称（英）" },
      { id: "context_cn", name: "名称（中）" },
      { id: "", name: "" },
    ];

    this.search();
  }

  private async getDictionary(query: SettingManagementListSettingRequest) {
    const result = await SettingManagementSettingService.adminSetting(query);
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
    });

    this.filter.page = result.data.paginator.currentPage;
    this.dictionary = result.data.setting;
  }
}
